module.exports = __webpack_public_path__ + "static/media/Footbal_Men_Goalkeeper__footba_A2_Rectangle_94_pattern@2x.cba89f1c.png";